<template>
  <div v-if="isCurrentPlanLoaded" class="plan-card-container">
    <div class="plan-card">
      <h6 class="plan-card-title">
        <div v-if="hasMailSuiteProduct(products)">
          {{ $t("mail") }}
          {{ $t("billingAndUpgrade.orderSummarySection.plan") }}:
          {{ currentMailPlanDetails.planDetails.displayName }} (
          {{ mailboxesDetails.active }}
          <span v-if="mailboxesDetails.isPlural">{{
            $t("mobile.planCard.planDetails.mailBoxes")
          }}</span>
          <span v-else>{{ $t("mobile.planCard.planDetails.mailbox") }}</span>
          )
        </div>
        <div v-if="hasSiteProduct(products)">
          {{ $t("site") }}
          {{ $t("billingAndUpgrade.orderSummarySection.plan") }}:
          {{ currentSitePlanDetails.planDetails.displayName }}
        </div>
      </h6>
      <span class="divider"></span>
      <ul class="item-list">
        <li>
          {{ $t("purchaseFlow.billingSection.billingCycle") }}:
          {{ $t("billingCycles." + currentPlanDetails.billingCycle) }}
        </li>
        <li>
          {{
            currentPlanDetails.autoRenew
              ? $t("mobile.planCard.planDetails.renewsOn")
              : $t("mobile.planCard.planDetails.expiresOn")
          }}:
          {{ formatDate(currentPlanDetails.expiresOn) }}
          <span
            v-if="showChangeBillingDate"
            class="change-renewal-date"
            @click="showChangeRenewalDateModal"
          >
            <img src="../../assets/edit-white.svg" />
            {{ $t("billingAndSubscription.changeRenewalDate.mobileLinkText") }}
          </span>
        </li>
      </ul>
    </div>
    <ChangeRenewalDate
      v-if="isChangeRenewalDateModalActive"
      @fetchCurrentPlan="fetchCurrentPlan"
      @close="hideChangeRenewalDateModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDate, hasMailSuiteProduct, hasSiteProduct } from "../../helpers";
import ChangeRenewalDate from "../BillingAndSubscription/ChangeRenewalDate.vue";
import bundleEvents from "@/telemetry/bundleEvents";

export default {
  methods: {
    hasSiteProduct,
    hasMailSuiteProduct,
    showChangeRenewalDateModal() {
      this.isChangeRenewalDateModalActive = true;
      bundleEvents.logChangeRenewalDateClicked();
    },
    hideChangeRenewalDateModal() {
      this.isChangeRenewalDateModalActive = false;
    },
    fetchCurrentPlan() {
      this.$emit("fetchCurrentPlan");
    },
  },
  data() {
    return {
      formatDate,
      isChangeRenewalDateModalActive: false,
    };
  },
  components: {
    ChangeRenewalDate,
  },
  computed: {
    ...mapGetters(["currentPlanDetails", "products"]),
    ...mapGetters({
      currentMailPlanDetails: "mail/currentProductDetails",
      currentSitePlanDetails: "site/currentProductDetails",
    }),
    isCurrentPlanLoaded() {
      return this.currentPlanDetails.bundleId;
    },
    showChangeBillingDate() {
      return false;
    },
    mailboxesDetails() {
      return {
        active: this.currentMailPlanDetails.noOfAccounts.active,
        isPlural: this.currentMailPlanDetails.noOfAccounts.active > 1,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.plan-card {
  padding: 12px 16px;
  border-radius: 4px;
  background-color: var(--mobile-plan-card);

  * {
    color: var(--white);
  }

  h6 {
    div:not(:last-of-type) {
      margin-bottom: 8px;
    }
  }

  h3 {
    margin-bottom: 12px;
  }

  .change-renewal-date {
    display: inline-flex;
    align-items: center;
    float: right;
    gap: 2px;
    font-size: 14px;
    font-weight: 400;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
}

.divider {
  height: 1px;
  display: block;
  background-color: var(--mobile-divider);
}

.item-list {
  list-style-type: none;
  padding-inline-start: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 0 0;
}
</style>
